<script>
  /**
   * Renders a component fetched the first time it is needed.
   *
   * App.svelte reaches almost every top-level surface, and a static import of
   * each puts all of them in the entry graph every visitor downloads before
   * first paint — though most visitors see none of them. Nothing renders while
   * the chunk is in flight, which is right for surfaces that appear in response
   * to something and wrong for chrome that must be in the first paint.
   */
  let { loader, ...rest } = $props()

  const module = loader()
</script>

{#await module then loaded}
  {@const Component = loaded.default}
  <Component {...rest} />
{/await}
